//Footer
$(window).resize(function () {
  if ($(window).width() >= 768) {
    $("#PlanSite").addClass("show");
  }
});
